import React from 'react';
function List(props){
    return(
        <>
        <ul>
             <li className= {props.ClassHead} >
            <a href = {props.Link}>
                {props.Title} </a>
                </li>
                </ul>
                </>)
                }
           
        
export default List;
